import React, { useContext } from 'react';
import './index.scss';

export default function CheckBox({ label, value, onChange }: {label: string, value: boolean, onChange: () => void}) {
  return (
    <label className="check-box">
      <input
        type="checkbox"
        checked={value}
        onChange={onChange}
      />
      {label}
    </label>
  );
}